/** The message the video-times window posts to its opener (the Layers
 *  page) once times are saved. Its own module so the two pages do not
 *  import each other. */
export const VIDEO_TIMES_SAVED = 'priori:video-times-saved'
